<div class="er-page er-kycpage">
  <div class="er-page-head">
    <p class="er-eyebrow">Account · KYC</p>
    <h1 class="er-page-title">Complete your KYC</h1>
  </div>

  <div class="er-card er-kycpage-card">

    <form [formGroup]="kycForm">
      <div>
        <mat-form-field appearance="outline" class="er-kycpage-field">
          <mat-label>Enter Aadhaar number</mat-label>
          <input matInput type='text' (keypress)="numberOnly($event)" maxlength="12" placeholder="Enter Aadhaar Number"
            formControlName="aadharNum" [errorStateMatcher]="matcher">
          <mat-error *ngIf="kycForm.hasError('required','aadharNum')">
            Aadhaar Number is required
          </mat-error>
          <span *ngIf='msgdivshow == true && opsmsg' class="msg-div">
            {{opsmsg}}
          </span>
        </mat-form-field>
      </div>
      <div>
        <mat-form-field appearance="outline" class="er-kycpage-field">
          <mat-label>Enter name as per Aadhaar card</mat-label>
          <input matInput type='text' placeholder="Enter Fullname" formControlName="fullName"
            [errorStateMatcher]="matcher">
          <mat-error *ngIf="kycForm.hasError('required','fullName')">
            Fullname is required
          </mat-error>

        </mat-form-field>
      </div>
      <div>
        <mat-form-field appearance="outline" class="er-kycpage-field">
          <mat-label>Enter mobile number</mat-label>
          <input matInput type="text" maxlength="10" (keypress)="numberOnly($event)" placeholder="Mobile Number"
            formControlName="mobileNum">
          <mat-error *ngIf="kycForm.hasError('required','mobileNum')">
            Mobile Number is required
          </mat-error>
        </mat-form-field>

      </div>
      <div *ngIf="showOTPDiv">
        <mat-form-field appearance="outline" class="er-kycpage-field">
          <mat-label>Enter OTP</mat-label>
          <input matInput type="text" maxlength="8" #otp (keypress)="numberOnly($event)" placeholder="Enter OTP"
            formControlName="otp">
          <mat-error *ngIf="kycForm.hasError('required','otp')">
            OTP field is required
          </mat-error>
        </mat-form-field>

      </div>
      <div>
        <mat-form-field appearance="outline" class="er-kycpage-field">
          <mat-label>Enter comment</mat-label>
          <textarea matInput max="100" placeholder="comment" formControlName="comment"></textarea>
          <mat-error *ngIf="kycForm.hasError('required','comment')">
            Comment field is required
          </mat-error>
        </mat-form-field>

      </div>
      <div>
        <mat-form-field appearance="outline" class="er-kycpage-field">
          <mat-label>Biometric</mat-label>
          <mat-select formControlName="device">
            <mat-option [value]="deviceObj.value" *ngFor="let deviceObj of devices">
              {{deviceObj.deviceName}}</mat-option>
          </mat-select>
          <mat-error *ngIf="kycForm.hasError('required','device')">
            Device is required
          </mat-error>
        </mat-form-field>
      </div>

      <button type="button" class="er-btn er-btn--primary" *ngIf="!showOTPDiv && !showCaptureBtn" id="submitBtn"
        (click)="sendOtp()">Send OTP
      </button>
      <button type="button" class="er-btn er-btn--primary" *ngIf="showOTPDiv" id="submitBtn" (click)="verifyOtp()">Verify OTP
      </button>
      <button type="button" class="er-btn er-btn--primary" *ngIf="showCaptureBtn" id="submitBtn" (click)="doKYC()"> Scan fingerprint &amp; submit
      </button>
    </form>


  </div>
</div>

